import axios from 'axios';

import type { EnvironmentDetailsApiResult } from 'libs/types/src/webapi';

export async function environmentDetailsQuery(): Promise<EnvironmentDetailsApiResult> {
  const response = await axios.get(`/api/admin/environment-details`);
  return response.data;
}
